import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

export const Route = createFileRoute("/$")({
	component: RouteComponent,
});

function RouteComponent() {
	const locale = useIntl().locale;
	return <Navigate to={"/404"} href={`/404?locale=${locale}`} replace />;
}
